import { BiSearch } from "react-icons/bi";
import s from "./delete.module.css";
import { useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import axios from "axios";
import { baseUrl } from "../service/Api";
import React from "react";

export default function DeleteUser() {
  const [numberField, setnumberField] = useState(true);
  const [deleteConfirmation, setdeleteConfirmation] = useState(false);
  const [number, setNumber] = useState();
  const [otp, setOtp] = useState();
  const [invalidOtp, setinvalidOtp] = useState();
  const [token, setToken] = useState(null);

  const senOtpToNumber = async () => {
    let temp = {
      mobile: number,
      // type:"delete"
    };
    try {
      let res = await axios.post(baseUrl + `/deleteUser/sendOtp`, temp);
      if (res?.data?.status) {
        console.log("otp send successfully");
      } else {
        console.log("Failed to send otp");
      }
    } catch (error) {
      console.error("error to sen otp :", error);
    }
  };
  const verifyOtp = async () => {
    let temp = {
      mobile: number,
      otp: otp,
    };
    try {
      let res = await axios.post(baseUrl + `/deleteUser/verifyOtp`, temp);

      if (res?.data?.status) {
        setToken(res?.data?.token);
        setdeleteConfirmation(true);
      } else {
        setinvalidOtp(true);
      }
    } catch (error) {
      setinvalidOtp(true);
      console.error("error to send otp : ", error);
    }
  };

  return (
    <>
      <div className="">
        <div className={s["delete_page"]}>
          <div className={s["pop_up"]}>
            {!numberField && (
              <div
                className={s["back_sign"]}
                onClick={() => setnumberField(true)}
              >
                <IoMdArrowBack />
              </div>
            )}
            <div className={s["warning_text"]}>DELETE ACCOUNT !</div>
            <div className="delete_sign">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="100"
                height="70"
                viewBox="0 0 100 100"
              >
                <path
                  fill="#ee3e54"
                  d="M13 27A2 2 0 1 0 13 31A2 2 0 1 0 13 27Z"
                ></path>
                <path
                  fill="#f1bc19"
                  d="M77 12A1 1 0 1 0 77 14A1 1 0 1 0 77 12Z"
                ></path>
                <path
                  fill="#fce0a2"
                  d="M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
                ></path>
                <path
                  fill="#f1bc19"
                  d="M83 11A4 4 0 1 0 83 19A4 4 0 1 0 83 11Z"
                ></path>
                <path
                  fill="#ee3e54"
                  d="M87 22A2 2 0 1 0 87 26A2 2 0 1 0 87 22Z"
                ></path>
                <path
                  fill="#fbcd59"
                  d="M81 74A2 2 0 1 0 81 78 2 2 0 1 0 81 74zM15 59A4 4 0 1 0 15 67 4 4 0 1 0 15 59z"
                ></path>
                <path
                  fill="#ee3e54"
                  d="M25 85A2 2 0 1 0 25 89A2 2 0 1 0 25 85Z"
                ></path>
                <path
                  fill="#fff"
                  d="M18.5 51A2.5 2.5 0 1 0 18.5 56A2.5 2.5 0 1 0 18.5 51Z"
                ></path>
                <path
                  fill="#f1bc19"
                  d="M21 66A1 1 0 1 0 21 68A1 1 0 1 0 21 66Z"
                ></path>
                <path
                  fill="#fff"
                  d="M80 33A1 1 0 1 0 80 35A1 1 0 1 0 80 33Z"
                ></path>
                <g>
                  <path
                    fill="#8b8bc1"
                    d="M41.7,74.3c-3.8,0-8-2.1-8-6.8V41.9l-3-3.5V35c0-4.8,2.1-6.7,7.1-6.7h24.3c5.1,0,7.1,2,7.1,6.7v3.5l-3,3.4 v25.6c0,4.6-4.2,6.8-8.1,6.8H41.7z"
                  ></path>
                  <path
                    fill="#472b29"
                    d="M62.2,29c5.4,0,6.4,2.3,6.4,6v0.2v1v2l-2.7,3l-0.3,0.4v0.5v25.4c0,4.2-3.7,6.1-7.4,6.1H41.7 c-3.6,0-7.3-1.9-7.3-6.1V42.2v-0.5l-0.3-0.4l-2.7-3.1v-2v-1V35c0-3.7,1.1-6,6.4-6L62.2,29 M62.2,27.6H37.8C32,27.6,30,30.2,30,35 v0.2v1v2.6l3,3.5v25.3c0,4.9,4.2,7.5,8.7,7.5h16.5c4.6,0,8.8-2.6,8.8-7.5V42.1l3-3.4v-2.6v-1V35C70,30.2,68,27.6,62.2,27.6 L62.2,27.6z"
                  ></path>
                  <path
                    fill="#6869ad"
                    d="M37.4 56.6V43.1c0-1 .9-1.8 1.9-1.8l0 0c1.1 0 1.9.8 1.9 1.8v13.2V67c0 1-.9 1.8-1.9 1.8l0 0c-1.1 0-1.9-.8-1.9-1.8v-2.2M44.3 56.6V43.1c0-1 .9-1.8 2-1.8l0 0c1.1 0 2 .8 2 1.8v13.2V67c0 1-.9 1.8-2 1.8l0 0c-1.1 0-2-.8-2-1.8v-2.2"
                  ></path>
                  <path
                    fill="#472b29"
                    d="M46.5 41.8c.9 0 1.7.6 1.7 1.3v13.2V67c0 .7-.8 1.3-1.7 1.3s-1.7-.6-1.7-1.3v-2.2-8.1V43.1C44.8 42.4 45.5 41.8 46.5 41.8M46.5 41.3c-1.2 0-2.2.8-2.2 1.8v13.6 8.1V67c0 1 1 1.8 2.2 1.8s2.2-.8 2.2-1.8V56.3 43.1C48.6 42.1 47.6 41.3 46.5 41.3L46.5 41.3zM39.5 68.8c-1.2 0-2.3-.9-2.3-2v-2.3c0-.1.1-.3.3-.3s.3.1.3.3v2.3c0 .8.8 1.5 1.8 1.5s1.8-.7 1.8-1.5V43.3c0-.8-.8-1.5-1.8-1.5s-1.8.7-1.8 1.5v9.2c0 .1-.1.3-.3.3s-.3-.1-.3-.3v-9.2c0-1.1 1-2 2.3-2s2.3.9 2.3 2v23.5C41.8 67.9 40.7 68.8 39.5 68.8z"
                  ></path>
                  <path
                    fill="#6869ad"
                    d="M51.4 56.6V43.1c0-1 .9-1.8 2-1.8l0 0c1.1 0 2 .8 2 1.8v13.2V67c0 1-.9 1.8-2 1.8l0 0c-1.1 0-2-.8-2-1.8v-2.2M58.5 56.6V43.1c0-1 .9-1.8 2-1.8l0 0c1.1 0 2 .8 2 1.8v13.2V67c0 1-.9 1.8-2 1.8l0 0c-1.1 0-2-.8-2-1.8v-2.2"
                  ></path>
                  <path
                    fill="#6869ad"
                    d="M51.4 56.6V43.1c0-1 .9-1.8 2-1.8l0 0c1.1 0 2 .8 2 1.8v13.2V67c0 1-.9 1.8-2 1.8l0 0c-1.1 0-2-.8-2-1.8v-2.2M58.5 56.6V43.1c0-1 1-1.8 2.2-1.8l0 0c1.2 0 2.2.8 2.2 1.8v13.2V67c0 1-1 1.8-2.2 1.8l0 0c-1.2 0-2.2-.8-2.2-1.8v-2.2"
                  ></path>
                  <path
                    fill="#472b29"
                    d="M53.5 41.8c.9 0 1.6.6 1.6 1.3v13.2V67c0 .7-.7 1.3-1.6 1.3s-1.6-.6-1.6-1.3v-2.2-8.1V43.1C51.9 42.4 52.7 41.8 53.5 41.8M53.5 41.3c-1.2 0-2.1.8-2.1 1.8v13.6 8.1V67c0 1 1 1.8 2.1 1.8s2.1-.8 2.1-1.8V56.3 43.1C55.7 42.1 54.7 41.3 53.5 41.3L53.5 41.3zM60.6 41.5c1 0 1.8.6 1.8 1.3v13.5 10.9c0 .7-.8 1.3-1.8 1.3s-1.8-.6-1.8-1.3v-2.3-8.3V42.8C58.8 42.1 59.7 41.5 60.6 41.5M60.6 41c-1.3 0-2.3.8-2.3 1.8v13.8 8.3 2.3c0 1 1 1.8 2.3 1.8s2.3-.8 2.3-1.8V56.3 42.8C63 41.8 61.9 41 60.6 41L60.6 41zM32.6 45.8v7.4h0c-1.2 0-2.2-.9-2.2-1.9v-3.7C30.4 46.6 31.4 45.8 32.6 45.8L32.6 45.8M34 44.4h-1.4c-2 0-3.6 1.5-3.6 3.3v3.7c0 1.8 1.6 3.3 3.6 3.3H34V44.4L34 44.4zM67.4 45.8c1.2 0 2.2.9 2.2 1.9v3.7c0 1-1 1.9-2.2 1.9h0L67.4 45.8 67.4 45.8M67.4 44.4H66v10.2h1.4c2 0 3.6-1.5 3.6-3.3v-3.7C71 45.9 69.4 44.4 67.4 44.4L67.4 44.4zM54.3 24.4c1.2 0 2.3 1.3 2.3 2.8v.3H43.4v-.3c0-1.5 1-2.8 2.3-2.8L54.3 24.4M54.3 23h-8.7c-2 0-3.7 1.9-3.7 4.2v1.7h16v-1.7C58 24.9 56.3 23 54.3 23L54.3 23zM68.2 39H31.5c-.1 0-.3-.1-.3-.3s.1-.3.3-.3h36.7c.1 0 .3.1.3.3S68.4 39 68.2 39zM61.5 32.8h-31c-.1 0-.3-.1-.3-.3s.1-.3.3-.3h31c.1 0 .3.1.3.3S61.6 32.8 61.5 32.8zM64.2 71.6H35.6c-.1 0-.3-.1-.3-.3s.1-.3.3-.3h28.5c.1 0 .3.1.3.3S64.3 71.6 64.2 71.6zM66.2 32.9h-3.1c-.1 0-.3-.1-.3-.3s.1-.3.3-.3h3.1c.1 0 .3.1.3.3S66.3 32.9 66.2 32.9zM37.5 58.8c-.1 0-.3-.1-.3-.3v-3.7c0-.1.1-.3.3-.3s.3.1.3.3v3.7C37.7 58.7 37.6 58.8 37.5 58.8z"
                  ></path>
                  <g>
                    <path
                      fill="#472b29"
                      d="M69.5,36h-39c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h39c0.3,0,0.5,0.2,0.5,0.5S69.8,36,69.5,36z"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            {numberField && (
              <div className={s["number_box"]}>
                <span>Phone Number</span>
                <div className={s["search-box"]}>
                  <span style={{ paddingRight: "0.5rem" }}>
                    <BiSearch size={23} />
                  </span>
                  <input
                    type="number"
                    onChange={(e) => {
                      setNumber(e.target.value);
                    }}
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
            )}
            {!numberField && (
              <div className={s["number_box"]}>
                <span>Enter Otp</span>
                <div className={s["search-box"]}>
                  <span style={{ paddingRight: "0.5rem" }}>
                    <BiSearch size={23} />
                  </span>
                  <input
                    type="text"
                    spellCheck="false"
                    onChange={(e) => {
                      setOtp(e.target.value);
                    }}
                    placeholder="Enter O.T.P"
                  />
                </div>
              </div>
            )}
            <div>
              {invalidOtp && (
                <div style={{ display: "inline-block" }}>
                  <span style={{ color: "red" }}>Invalid Otp!</span>
                </div>
              )}
            </div>

            <div className={s["button"]}>
              {numberField && (
                <span
                  onClick={() => {
                    setnumberField(false);
                    senOtpToNumber();
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div className="div" style={{ margin: "auto" }}>
                      Send Otp
                    </div>
                  </div>
                </span>
              )}
              {!numberField && (
                <span
                  onClick={() => {
                    verifyOtp();
                  }}
                >
                  <div style={{ margin: "auto", display: "flex" }}>
                    <div className="div" style={{ margin: "auto" }}>
                      Delete
                    </div>
                  </div>
                </span>
              )}
            </div>
          </div>
        </div>
        <DeletePopUp
          open={deleteConfirmation}
          setOpen={setdeleteConfirmation}
          token={token}
          setPopUp={setnumberField}
          mobNumber={number}
        />
      </div>
    </>
  );
}

function DeletePopUp({ open, setOpen, token, setPopUp, number }) {
  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  //  account delete permanently
  const deletePermanent = async () => {
    let temp = { token };
    try {
      let res = await axios.delete(baseUrl + `/deleteUser/delete`, temp, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });
      if (res?.data?.status) {
        setPopUp(true);
        throw new Error("Account Deleted");
        // notificationHandler({
        //   type: "success",
        //   msg: " Account Delete Successfully",
        // });
        handleClose();
      } else {
        console.log("Failed to delete Account:");
      }
    } catch (error) {
      console.error("Error in account delete:", error);
    }
  };
  return (
    <>
      {open && (
        <div className={s["modal-overlay"]}>
          <div className={s["modal"]}>
            <button className={s["close-btn"]} onClick={handleClose}>
              &times;
            </button>
            <div className={s["modal-icon"]}>
              <img
                src="https://img.icons8.com/color/48/000000/error--v1.png"
                alt="Warning"
              />
            </div>
            <h5>Are you sure you want to delete your account permanently?</h5>
            <p>
              Press <strong>"Delete account"</strong> to remove it permanently,
              or <strong>"Cancel"</strong> to keep your account.
            </p>
            <div className={s["modal-actions"]}>
              <button className={s["delete-btn"]} onClick={deletePermanent}>
                Delete account
              </button>
              <button className={s["cancel-btn"]} onClick={handleClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
